// react
import React, { Fragment, useEffect, useState } from "react";
// store
import { PAGINATION_LIMIT } from "../../../../store/config";
//import { paginationChangePage } from "../../../../store/services/helpers/functions";
// components
import ProviderDetail from "./ProviderDetail";
import ButtonIconDetail from "../../../../components/buttons/ButtonIconDetail";
import DimmerLoader from "../../../../components/others/DimmerLoader";
import { Table, Header, Pagination, Card, Icon, Label } from "semantic-ui-react";

// components
function CoachNetworkTable({ providers, isLoading }) {
    // state
    const [providerList, setProviderList] = useState(
        providers.slice(0, PAGINATION_LIMIT)
    );
    const [modalOpen, setModalOpen] = useState(false);
    const [providerData, setProviderData] = useState({});
    const [isMobile, setIsMobile] = useState(false);

    // set data to table
    useEffect(() => {
        setProviderList(providers.slice(0, PAGINATION_LIMIT));
    }, [providers]);

    useEffect(() => {
        const media = window.matchMedia("(max-width: 768px)");
        const handleChange = () => setIsMobile(media.matches);
        handleChange();
        if (media.addEventListener) {
            media.addEventListener("change", handleChange);
        } else {
            media.addListener(handleChange);
        }
        return () => {
            if (media.removeEventListener) {
                media.removeEventListener("change", handleChange);
            } else {
                media.removeListener(handleChange);
            }
        };
    }, []);

    /** component functions **/

    const handleModalOpen = (provider) => {
        setProviderData(provider);
        setModalOpen(true);
    };

    const handleModalClose = () => {
        setModalOpen(false);
    };

    const handleChangePage = (event, data) => {
        setProviderList(
            providers.slice(
                data.activePage * PAGINATION_LIMIT - PAGINATION_LIMIT,
                data.activePage * PAGINATION_LIMIT
            )
        );
    };

    // template
    const totalPages = Math.ceil(providers.length / PAGINATION_LIMIT) || 1;

    return (
        <Fragment>
            <DimmerLoader active={isLoading} />
            {isMobile ? (
                <div>
                    {providerList.length === 0 && (
                        <Card fluid style={{ borderRadius: "16px", textAlign: "center", boxShadow: "0 4px 16px rgba(0,0,0,0.06)", border: "1px solid rgba(0,0,0,0.06)" }}>
                            <Card.Content style={{ padding: "2rem 1rem" }}>
                                <div style={{ color: "rgba(0,0,0,0.4)", marginBottom: "0.5rem", display: "flex", justifyContent: "center" }}>
                                    <Icon name="inbox" style={{ fontSize: "2.5rem", margin: 0 }} />
                                </div>
                                <strong style={{ fontSize: "0.95rem", color: "rgba(0,0,0,0.7)", lineHeight: 1.4 }}>Nemáte žiadnych poskytovateľov v sieti</strong>
                            </Card.Content>
                        </Card>
                    )}
                    {providerList.map((provider, providerId) => (
                        <Card key={providerId} fluid style={{ marginBottom: "1rem", borderRadius: "16px", overflow: "hidden", boxShadow: "0 4px 16px rgba(0,0,0,0.08)", border: "1px solid rgba(0,0,0,0.06)", background: "#fff" }}>
                            <Card.Content style={{ padding: "1rem 1.1rem", background: "linear-gradient(135deg, rgba(33,133,208,0.04) 0%, rgba(255,255,255,0) 100%)" }}>
                                <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: "0.7rem" }}>
                                    <div style={{ flex: 1, minWidth: 0 }}>
                                        <div style={{ fontSize: "0.7rem", fontWeight: 600, color: "rgba(0,0,0,0.45)", textTransform: "uppercase", letterSpacing: "0.5px", marginBottom: "0.25rem" }}>Poskytovateľ</div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", lineHeight: 1.3, marginBottom: "0.4rem" }}>
                                            {provider.firstname} {provider.lastname}
                                        </div>
                                        <div style={{ fontSize: "0.8rem", color: "rgba(0,0,0,0.6)", fontWeight: 500 }}>
                                            <Icon name="mail" style={{ margin: "0 0.3rem 0 0", fontSize: "0.8rem" }} />
                                            {provider.user?.email}
                                        </div>
                                    </div>
                                    <div style={{ display: "inline-flex", justifyContent: "center", padding: "0.35rem 0.75rem", borderRadius: "20px", background: provider.user?.is_active ? "#00a651" : "#db2828", color: "#fff", fontWeight: 700, fontSize: "0.75rem", lineHeight: 1.2, whiteSpace: "nowrap", boxShadow: provider.user?.is_active ? "0 2px 8px rgba(0,166,81,0.25)" : "0 2px 8px rgba(219,40,40,0.25)", marginLeft: "0.5rem" }}>
                                        <Icon name={provider.user?.is_active ? "check circle" : "times circle"} style={{ margin: "0 0.3rem 0 0", fontSize: "0.85rem" }} />
                                        {provider.user?.is_active ? "Aktívny" : "Neaktívny"}
                                    </div>
                                </div>
                            </Card.Content>
                            <Card.Content style={{ padding: "1rem 1.1rem", background: "#fafafa" }}>
                                <div style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)", gap: "0.75rem" }}>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                            <Icon name="calendar alternate outline" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Registrovaný</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "0.9rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>{provider.created}</div>
                                    </div>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)" }}>
                                        <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                            <Icon name="soccer" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Aktivity</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>{provider.offers?.length || 0}</div>
                                    </div>
                                    <div style={{ padding: "0.65rem 0.75rem", borderRadius: "12px", background: "#fff", border: "1px solid rgba(0,0,0,0.08)", gridColumn: "1 / -1" }}>
                                        <div style={{ marginBottom: "0.4rem", paddingLeft: "0.15rem" }}>
                                            <Icon name="chart line" style={{ margin: "0 0.3rem 0 0", fontSize: "0.75rem", color: "rgba(0,0,0,0.4)" }} />
                                            <span style={{ fontSize: "0.7rem", color: "rgba(0,0,0,0.5)", fontWeight: 600, textTransform: "uppercase", letterSpacing: "0.3px" }}>Obrat</span>
                                        </div>
                                        <div style={{ fontWeight: 700, fontSize: "1.05rem", color: "#1a1a1a", paddingLeft: "0.15rem" }}>0 EUR</div>
                                    </div>
                                </div>
                            </Card.Content>
                            <Card.Content style={{ padding: "0.75rem 1.1rem", background: "var(--primary)", borderTop: "none" }}>
                                <div onClick={() => handleModalOpen(provider)} style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "0.5rem", color: "#fff", fontWeight: 700, fontSize: "0.9rem", textDecoration: "none", cursor: "pointer", lineHeight: 1 }}>
                                    <Icon name="eye" style={{ margin: 0, fontSize: "1rem" }} />
                                    <span>Zobraziť detail</span>
                                </div>
                            </Card.Content>
                        </Card>
                    ))}
                    {totalPages > 1 && (
                        <div style={{ display: "flex", justifyContent: "center", marginTop: "1.5rem", marginBottom: "1rem" }}>
                            <Pagination
                                defaultActivePage={1}
                                totalPages={totalPages}
                                onPageChange={handleChangePage}
                                boundaryRange={0}
                                siblingRange={1}
                            />
                        </div>
                    )}
                </div>
            ) : (
                <Card fluid style={{ borderRadius: "8px", boxShadow: "none", border: "1px solid #e0e0e0" }}>
                    <Card.Content style={{ padding: "0.5rem 0.75rem" }}>
                        <div style={{ overflowX: "auto" }}>
                            <Table striped unstackable style={{ minWidth: "900px" }}>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell>Meno</Table.HeaderCell>
                                        <Table.HeaderCell textAlign="center">
                                            Aktívny
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign="center">
                                            Dátum registrácie
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign="center">
                                            Počet aktivít
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign="center">
                                            Obrat
                                        </Table.HeaderCell>
                                        <Table.HeaderCell textAlign="center">
                                            Akcia
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Header>

                                <Table.Body>
                                    {providerList.length === 0 &&
                                        <Table.Row>
                                            <Table.Cell colSpan={6} style={{ textAlign: "center", fontWeight: "bold" }}>
                                                Nemáte žiadnych poskytovateľov v sieti
                                            </Table.Cell>
                                        </Table.Row>
                                    }
                                    {providerList.map((provider, providerId) => (
                                        <Table.Row key={providerId}>
                                            <Table.Cell>
                                                <Header as="h5">
                                                    {provider.firstname} {provider.lastname}{" "}
                                                    <br />
                                                    <small>{provider.user?.email}</small>
                                                </Header>
                                            </Table.Cell>
                                            <Table.Cell textAlign="center">
                                                {provider.user?.is_active ? (
                                                    <Label color="green" size="tiny">Áno</Label>
                                                ) : (
                                                    <Label color="red" size="tiny">Nie</Label>
                                                )}
                                            </Table.Cell>
                                            <Table.Cell textAlign="center">
                                                {provider.created}
                                            </Table.Cell>
                                            <Table.Cell textAlign="center">
                                                {provider.offers?.length || 0}
                                            </Table.Cell>
                                            <Table.Cell textAlign="center">0 €</Table.Cell>
                                            <Table.Cell textAlign="center">
                                                <ButtonIconDetail
                                                    title="Zobraziť detail"
                                                    onClick={() => handleModalOpen(provider)}
                                                />
                                            </Table.Cell>
                                        </Table.Row>
                                    ))}
                                </Table.Body>

                                <Table.Footer>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan="6">
                                            <Pagination
                                                defaultActivePage={1}
                                                totalPages={totalPages}
                                                onPageChange={handleChangePage}
                                                boundaryRange={0}
                                                siblingRange={0}
                                            />
                                        </Table.HeaderCell>
                                    </Table.Row>
                                </Table.Footer>
                            </Table>
                        </div>
                    </Card.Content>
                </Card>
            )}

            <ProviderDetail
                modalOpen={modalOpen}
                handleModalClose={handleModalClose}
                provider={providerData}
            />
        </Fragment>
    );
}

export default CoachNetworkTable;
